import { render, staticRenderFns } from "./Sections.vue?vue&type=template&id=c2982666&scoped=true&"
import script from "./Sections.vue?vue&type=script&lang=ts&"
export * from "./Sections.vue?vue&type=script&lang=ts&"
import style0 from "./Sections.vue?vue&type=style&index=0&id=c2982666&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2982666",
  null
  
)

export default component.exports